import { useAppDispatch, useAppSelector } from 'app/hooks';
import { Babies } from 'components/elements/babies/Babies';
import { CloseButton } from 'components/elements/closeButton/CloseButton';
import { Policy } from 'components/elements/policy/Policy';
import { DatePicker } from 'components/forms/DatePicker/DatePicker';
import { Input } from 'components/forms/input/Input';
import { Select } from 'components/forms/select/Select';
import { openTextModal, openThanks } from 'features/common/common.slice';
import { FormEventHandler, MouseEventHandler } from 'react';
import { batch } from 'react-redux';
import { getAdultOptions, getBabyOptions } from 'utils/helpers/booking.helpers';
import {
  changeCalculationAdults,
  changeCalculationBabies,
  clearCalculation,
  closeCalculation,
  closeCalculationArrival,
  closeCalculationBabies,
  closeCalculationDeparture,
  openCalculationArrival,
  openCalculationBabies,
  openCalculationDeparture,
  selectCalculation,
  setCalculationArrival,
  setCalculationBaby,
  setCalculationDeparture,
  // setCalculationEmail,
  setCalculationMessenger,
  setCalculationName,
  setCalculationPhone,
  toggleCalculationPolicy,
} from '../calculation.slice';
import styles from './calculationBody.module.scss';
import { Radio } from 'components/forms/radio/Radio';

declare const ym: any;
declare const _tmr: any;
// declare const gtag: any;

export const CalculationBody = () => {
  const dispatch = useAppDispatch();
  const {
    type,
    room,
    arrival,
    departure,
    adults,
    babies,
    name,
    // email,
    phone,
    messenger,
    policyChecked,
    ui,
  } = useAppSelector(selectCalculation);

  const handleSubmit: FormEventHandler<HTMLFormElement> = async (event) => {
    event.preventDefault();

    if (arrival === null) {
      dispatch(openCalculationArrival());
      return;
    }
    if (departure === null) {
      dispatch(openCalculationDeparture());
      return;
    }

    ym(88678071, 'reachGoal', 'kick');
    _tmr.push({ type: 'reachGoal', id: 3733626, goal: 'arrow' });
    // ym(87397023, 'reachGoal', 'kick');
    // gtag('event', 'submit', { event_category: 'form' });

    dispatch(closeCalculation());
    setTimeout(() => dispatch(openThanks('request')), 300);

    await fetch('/ajax/_forms.php', {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json',
      },
      body: JSON.stringify({
        form: type === 'calculation' ? 'Расчет стоимости' : 'Бронирование',
        room,
        arrival: new Date(arrival).toLocaleDateString(),
        departure: new Date(departure).toLocaleDateString(),
        adults,
        babies,
        name,
        // email,
        phone,
        messenger,
      }),
    });

    dispatch(clearCalculation());
  };

  const handleConfirm: MouseEventHandler<HTMLButtonElement> = (event) => {
    if (arrival === null) {
      dispatch(openCalculationArrival());
      event.preventDefault();
      return;
    }
    if (departure === null) {
      dispatch(openCalculationDeparture());
      event.preventDefault();
      return;
    }
  };

  const titles = {
    calculation: 'Расчет стоимости',
    booking: 'Бронирование',
  };

  return (
    <div className={styles.module}>
      <CloseButton
        className={styles.close}
        onClick={() => dispatch(closeCalculation())}
      />

      <form className={styles.form} onSubmit={handleSubmit}>
        <h2 className={styles.title}>{titles[type]}</h2>
        <DatePicker
          className={styles.arrival}
          name="Дата заезда"
          isOpen={ui.arrivalOpened}
          disabledDaysBefore={new Date()}
          onClick={() =>
            dispatch(
              ui.arrivalOpened
                ? closeCalculationArrival()
                : openCalculationArrival(),
            )
          }
          onOutsideClick={() => dispatch(closeCalculationArrival())}
          onDayClick={(date) => {
            batch(() => {
              dispatch(setCalculationArrival(date.valueOf()));
              dispatch(closeCalculationArrival());
            });
          }}
          value={arrival}
        />
        <DatePicker
          className={styles.arrival}
          name="Дата отъезда"
          isOpen={ui.departureOpened}
          disabledDaysBefore={arrival ? new Date(arrival) : new Date()}
          onClick={() =>
            dispatch(
              ui.departureOpened
                ? closeCalculationDeparture()
                : openCalculationDeparture(),
            )
          }
          onOutsideClick={() => dispatch(closeCalculationDeparture())}
          onDayClick={(date) => {
            batch(() => {
              dispatch(setCalculationDeparture(date.valueOf()));
              dispatch(closeCalculationDeparture());
            });
          }}
          value={departure}
        />
        <Select
          className={styles.adults}
          title="Кол-во взрослых"
          paddingLeft={154}
          options={getAdultOptions()}
          onChange={(event) =>
            dispatch(changeCalculationAdults(+event.target.value))
          }
          value={adults}
        />
        <Select
          className={styles.babies}
          title="Кол-во детей"
          paddingLeft={120}
          options={getBabyOptions()}
          onChange={(event) =>
            dispatch(changeCalculationBabies(+event.target.value))
          }
          value={babies.length}
        />
        {babies.length > 0 && (
          <Babies
            className={styles.babyList}
            isOpen={ui.babiesOpened}
            onClick={() =>
              dispatch(
                ui.babiesOpened
                  ? closeCalculationBabies()
                  : openCalculationBabies(),
              )
            }
            onOutsideOrConfirmClick={() => dispatch(closeCalculationBabies())}
            onSetBaby={(idx, age) => dispatch(setCalculationBaby({ idx, age }))}
            babies={babies}
          />
        )}
        <Input
          className={styles.name}
          placeholder="Имя"
          value={name}
          onChange={(event) => dispatch(setCalculationName(event.target.value))}
        />

        {/* <Input
          className={styles.email}
          placeholder="E-mail"
          type="email"
          value={email}
          onChange={(event) =>
            dispatch(setCalculationEmail(event.target.value))
          }
        /> */}

        <Input
          className={styles.phone}
          placeholder="Телефон"
          type="tel"
          pattern="^\+?[0-9()\- ]+"
          required
          value={phone}
          onChange={(event) =>
            dispatch(setCalculationPhone(event.target.value))
          }
        />

        <div className={styles.messenger}>
          <p className={styles.subtitle}>Куда отправить расчет?</p>

          <div className={styles.radios}>
            <label className={styles.label}>
              <Radio
                name="messenger"
                value="Whatsapp"
                checked={messenger === 'Whatsapp'}
                onChange={() => dispatch(setCalculationMessenger('Whatsapp'))}
              />
              <span>Whatsapp</span>
            </label>

            <label className={styles.label}>
              <Radio
                name="messenger"
                value="Telegram"
                checked={messenger === 'Telegram'}
                onChange={() => dispatch(setCalculationMessenger('Telegram'))}
              />
              <span>Telegram</span>
            </label>

            <label className={styles.label}>
              <Radio
                name="messenger"
                value="Max"
                checked={messenger === 'Max'}
                onChange={() => dispatch(setCalculationMessenger('Max'))}
              />
              <span>Max</span>
            </label>
          </div>
        </div>

        <Policy
          className={styles.policy}
          required
          checked={policyChecked}
          onChange={() => dispatch(toggleCalculationPolicy())}
          onClick={() => dispatch(openTextModal('policy'))}
        />

        <button className={styles.button} onClick={handleConfirm}>
          Отправить
        </button>
      </form>
    </div>
  );
};
